import React from 'react';
import Link from 'next/link';
import queryString from 'query-string';

import { getPageNumbers } from './getPageNumber';
import Item from './Item';
import List from './List';

import { ArrowLeftIcon, ArrowRightIcon } from '@/public/icons';

interface PaginationProps {
  currentPage: number;
  pageSize: number;
  total: number;
  search: string;
}

export const Pagination = ({
  total,
  currentPage,
  pageSize,
}: PaginationProps) => {
  const url = (page: number | string) => {
    if (page === 1) {
      return window.location.pathname;
    }
    return `?${queryString.stringify({
      page,
    })}`;
  };

  const isLastPage = currentPage * pageSize >= total;

  const pageNumbers = getPageNumbers({ currentPage, pageSize, total });

  return (
    <List>
      {currentPage !== 1 && (
        <Link href={url(currentPage - 1)}>
          <ArrowLeftIcon />
        </Link>
      )}

      {pageNumbers.map((pageNumber, i) =>
        pageNumber === '...' ? (
          <Item key={`${pageNumber}${i}`}>&hellip;</Item>
        ) : (
          <Item key={pageNumber} isActive={pageNumber === currentPage}>
            <Link
              href={url(pageNumber)}
              prefetch={false}
              passHref
              legacyBehavior
            >
              {pageNumber}
            </Link>
          </Item>
        )
      )}

      {!isLastPage && (
        <Link href={url(currentPage + 1)}>
          <ArrowRightIcon />
        </Link>
      )}
    </List>
  );
};
